import ShopMoreProduct from '../ShopMoreProduct/ShopMoreProduct'

const ShopMoreProducts = ({ products, mainProduct, queryTerm, queryType }) => {
    let queryTermDecoded = decodeURIComponent(queryTerm)

    // console.log('mainProduct, products', mainProduct, products)

    return (
        <div className="shop-more-products-outer">
            <div className="shop-more-products-inner">
                {products && products.length ? (
                    <ul className="products-list product-list shop-more-products nostyle">
                        {products.map((p) => {
                            return (
                                <ShopMoreProduct
                                    key={p.id}
                                    product={p}
                                    queryTerm={queryTermDecoded}
                                    queryType={queryType}
                                />
                            )
                        })}
                    </ul>
                ) : (
                    <div className="loading">Loading</div>
                )}
            </div>
        </div>
    )
}

export default ShopMoreProducts
